// TODO: Refactor to enum type
export const CARD_RENDER_LOCATION = {
	PROGRAM_FEED: 'PROGRAM_FEED',
	FAVORITE: 'FAVORITE',
	DASHBOARD: 'DASHBOARD',
	POOL: 'POOL',
	POOL_CUSTOM: 'POOL_CUSTOM',
	OPTIONAL: 'OPTIONAL',
};

export type CardRenderLocationType = keyof typeof CARD_RENDER_LOCATION;

export default CARD_RENDER_LOCATION;
